import Vuetable from 'vuetable-2/src/components/Vuetable';
import Avatar from '@/components/Avatar/Avatar';
import LabelList from '@/components/LabelList';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import Input from '@/components/Input/Input';
import Highlight from '@/components/Highlight';
import Pagination from '@/components/Pagination';
import CustomTable from '@/components/Table';
import sort from '@/utils/Sort';
import Context from '@/models/Context';
import Group from '@/models/core/Group';
import MultiSelectSearch from '@/components/MultiSelectSearch/MultiSelectSearch';

export default {
  name: 'GroupMemberTable',
  components: {
    Vuetable,
    Avatar,
    LabelList,
    Button,
    Input,
    Modal,
    MultiSelectSearch,
    Highlight,
    Pagination,
    CustomTable
  },
  props: ['members', 'selected'],
  watch: {
    members(newValue, oldValue) {
      this.reset = true;
    }
  },
  data() {
    return {
      reset: false,
      currentPage: 1,
      paginationItems: 10,
      sortOrder: 'asc',
      sortColumn: 'user.fullName',
      single: {
        member: null,
        candidateText: '',
        original: null
      },
      selectedUsers: [],
      searchFor: [],
      modal: {
        delete: {
          single: false,
          multiple: false
        },
        update: false,
        create: false
      },
      newInvites: {
        email: [],
        message: ''
      },
      columns: [
        { name: '', type: 'Avatar', key: 'user.avatarUrl' },
        {
          name: 'Name',
          type: 'MultiLine',
          key: 'user.fullName',
          secondary: 'user.username',
          has_sort: true
        },
        { name: 'Roles', type: 'Default', key: 'level', has_sort: true },
        { name: 'Groups', type: 'LabelList', key: 'groups' }
      ]
    };
  },
  computed: {
    paging() {
      const start = (this.currentPage - 1) * this.paginationItems;

      return {
        start: start,
        end: start + this.paginationItems
      };
    },
    shouldHighlight() {
      const highlight = [];

      this.searchFor.map(search => {
        if (search.type === 'fuzzy') {
          highlight.push(search.id);
        }
      });

      return highlight;
    },
    searchGroups() {
      const groups = Group.query()
        .orderBy('name')
        .get()
        .map(group => {
          return { id: group.id, name: `Group: ${group.name}`, type: 'group' };
        });

      const options = [
        {
          groupName: 'Groups',
          groupValues: groups
        }
      ];

      return options;
    },
    searchOptions() {
      const groups = Group.query()
        .orderBy('name')
        .get()
        .map(group => {
          return { id: group.id, name: `Group: ${group.name}`, type: 'group' };
        });

      const roles = [
        { id: 'creator', name: 'Role: Creator', type: 'role' },
        { id: 'editor', name: 'Role: Editor', type: 'role' },
        { id: 'master', name: 'Role: Master', type: 'role' },
        { id: 'publisher', name: 'Role: Publisher', type: 'role' }
      ];

      const options = [
        {
          groupName: 'Groups',
          groupValues: groups
        },
        {
          groupName: 'Roles',
          groupValues: roles
        }
      ];

      return options;
    },
    filteredMembers() {
      return this.members.filter(current => {
        let shouldReturn = !this.searchFor.length;

        this.searchFor.map(search => {
          if (search.type === 'fuzzy' && !shouldReturn) {
            shouldReturn =
              current.user.fullName.toLowerCase().indexOf(search.id) > -1 ||
              current.user.username.toLowerCase().indexOf(search.id) > -1;
          }

          if (search.type === 'role' && !shouldReturn) {
            shouldReturn = current.level.toLowerCase().indexOf(search.id) > -1;
          }

          if (search.type === 'group' && !shouldReturn) {
            shouldReturn = current.groups_collection.includes(search.id);
          }
        });

        if (shouldReturn) {
          return current;
        }
      });
    },
    sortedMembers() {
      return sort(this.filteredMembers, this.sortColumn, this.sortOrder).slice(
        this.paging.start,
        this.paging.end
      );
    },
    iconDirection() {
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down';
    },
    allSelected() {
      return this.selected.length === this.sortedMembers.length;
    },
    deleteCandidateText() {
      return this.selectedUsers.length === 1
        ? this.selectedUsers[0].user.fullName.trim().length
          ? this.selectedUsers[0].user.fullName
          : `${this.selectedUsers.length} user`
        : `${this.selectedUsers.length} users`;
    }
  },
  methods: {
    resetPage() {
      this.selectedUsers = [];
      this.reset = true;
    },
    onMultiAction(value) {
      this.selected.push(value);
    },
    sortOn(column) {
      if (column === this.sortColumn) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },
    select(value) {
      if (this.selected.includes(value.id)) {
        const index = this.selected.indexOf(value.id);
        this.selected.splice(index, 1);
      } else {
        this.selected.push(value.id);
      }
    },
    selectAll() {
      if (this.allSelected) {
        this.sortedMembers.map(member => {
          if (this.selected.includes(member.id)) {
            const index = this.selected.indexOf(member.id);
            this.selected.splice(index, 1);
          }
        });
      } else {
        this.sortedMembers.map(member => {
          if (!this.selected.includes(member.id)) {
            this.selected.push(member.id);
          }
        });
      }
    },
    isSelected(value) {
      return this.selected.includes(value.id) ? 'checked' : '';
    },
    namesOnly(original) {
      return original.map(item => {
        return item.name;
      });
    },
    updateCurrentPage(currentPage) {
      this.currentPage = currentPage;
    }
  }
};
